import { FC } from 'react';

import styles from './Fade.module.scss';
import { Transition } from './Transition';
import { TransitionProps } from './transitions.type';

export const Fade: FC<TransitionProps> = (props) => <Transition {...props} styles={styles} />;
